import React from 'react'
import { Link } from 'react-router-dom'

type Props = {}

const Community = (props: Props) => {
  return (
    <>
        <p className='pb-3'>Want to stay in the loop with our latest campaigns and offers? Join our community!</p>
        <div className='d-flex flex-column align-items-start gap-3' >
            <Link to="https://chat.whatsapp.com/DWRDrtYIJEc3UydWrL4WhI" target='_blank' className='btn btn-text-link'>Join WhatsApp community</Link>
            <Link to="https://t.me/ClanConnect" target='_blank' className='btn btn-text-link'>Join Telegram community</Link>
        </div>
    </>
  )
}

export default Community